import { render } from "./PlotRentArrearsReport.vue?vue&type=template&id=50d7d12f&scoped=true"
import script from "./PlotRentArrearsReport.vue?vue&type=script&lang=js"
export * from "./PlotRentArrearsReport.vue?vue&type=script&lang=js"

import "./PlotRentArrearsReport.vue?vue&type=style&index=0&id=50d7d12f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d7d12f"]])

export default __exports__